import z from 'zod';
import { Currencies } from '.'; // 👈 Usamos el enum global
import { PaymentSnapshotSchema } from './finance/payment-method-schema';
import { AuditSchema } from './settings/audit-schema';

// --- ENUMS DE LÓGICA ---

export const TransactionDirectionSchema = z.enum([
  'income',      // Dinero que entra al negocio
  'expense',     // Dinero que sale (ej: pago de nómina)
  'debt_created', // Deuda laboral (ej: prestaciones acumuladas)
]);

export const TransactionPurposeSchema = z.enum([
  'salary_payment',
  'nominal_bonus',
  'nominal_deduction',
  'cestaticket_payment',
  'advance_payment',      // Vales/Adelantos
  'settlement_payment',   // Liquidación
  'other_expense',
]);

// --- ESQUEMA PRINCIPAL ---

export const TransactionSchema = z.object({
  employeeId: z.string().nullable().optional(), // Referencia al empleado
  businessId: z.string(),
  payrollCycleId: z.string().nullable().optional(), // Referencia al lote de nómina
  
  direction: TransactionDirectionSchema,
  purpose: TransactionPurposeSchema,

  // 💰 Array de snapshots unificados (Métodos de pago usados)
  payments: z
    .array(PaymentSnapshotSchema)
    .min(1, 'Debe haber al menos un pago'),

  // 🛡️ NORMALIZACIÓN MULTIDIVISA
  accounting_currency: Currencies.default('USD'),
  total_amount_accounting: z.number().min(0.01),
  tasa_at_moment: z.number().min(1),
  
  // 🇻🇪 Monto en Bolívares (para trazabilidad local)
  total_amount_native_bs: z.number().default(0),

  audit: AuditSchema,
});
/**
 * 📥 TransactionInput
 * Lo que envías desde la UI o los servicios al crear una transacción.
 * Omitimos 'audit' porque el TransactionService.prepareCreate lo genera.
 */
export type TransactionInput = Omit<z.infer<typeof TransactionSchema>, 'audit'>;

/**
 * 🧾 Transaction
 * El objeto completo tal cual vive en la base de datos (con auditoría).
 */
export type Transaction = z.infer<typeof TransactionSchema>;

/**
 * 🆔 TransactionWithId
 * Lo que recibes de la base de datos después de un fetch.
 */
export type TransactionWithId = Transaction & { id: string };
